/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OPMInputSetSource = {
  source_type: OPMInputSetSource.source_type;
  id: number;
  name: string;
};
export namespace OPMInputSetSource {
  export enum source_type {
    ALLOCATION_SCENARIO = 'allocation_scenario',
    BACKSOLVE = 'backsolve',
    FUTURE_EXIT = 'future_exit',
    OPM_CALCULATOR = 'opm_calculator',
  }
}

